"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadCarmineImportTemplate = downloadCarmineImportTemplate;
exports.downloadKami = downloadKami;
exports.downloadKamiList = downloadKamiList;
exports.getCardDetailList = getCardDetailList;
exports.getPlatFormList = getPlatFormList;
exports.getProductSkuList = getProductSkuList;
exports.importBindCard = importBindCard;
exports.kamiDetailLists = kamiDetailLists;
exports.removeKami = removeKami;
exports.saveCardConfig = saveCardConfig;
exports.updateCard = updateCard;
var _request = _interopRequireDefault(require("@/utils/request"));
var _index = require("@/utils/index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getPlatFormList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/platform/card/list',
    method: 'post',
    data: data
  });
}
function getProductSkuList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/store/sku/list',
    method: 'GET',
    params: params,
    paramsSerializer: function paramsSerializer(currentParams) {
      return (0, _index.param)(currentParams);
    }
  });
}
function updateCard() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/platform/card/carmine/save',
    method: 'post',
    data: data
  });
}
function getCardDetailList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/platform/card/carmine/list',
    method: 'GET',
    params: params
  });
}
function importBindCard(data, skuId) {
  return (0, _request.default)({
    url: "/admin/platform/card/carmine/import-bind",
    method: 'post',
    params: {
      skuId: skuId
    },
    data: data
  });
}
function downloadCarmineImportTemplate() {
  return (0, _request.default)({
    url: '/admin/export/excel/template',
    method: 'get',
    params: {
      fileName: 'platform_card_carmine_import_template.xlsx'
    }
  });
}
function downloadKami(params) {
  return (0, _request.default)({
    url: "/admin/platform/card/carmine/download",
    method: 'post',
    params: params
  });
}
function downloadKamiList(data) {
  return (0, _request.default)({
    url: "/admin/platform/card/carmine/export",
    method: 'post',
    data: data
  });
}
function kamiDetailLists(data) {
  return (0, _request.default)({
    url: "/admin/platform/card/carmine/list",
    method: 'post',
    data: data
  });
}
function removeKami(data) {
  return (0, _request.default)({
    url: "/admin/platform/card/carmine/remove",
    method: 'post',
    data: data
  });
}
function saveCardConfig() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/platform/card/config/save',
    method: 'post',
    data: data
  });
}